export default "__VITE_ASSET__qM$R8Kxh__"